import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Search, TriangleAlert } from 'lucide-react';
import { StateShell } from '@/components/common/StateShell';
import { searchShortcut, useSearchPalette } from '@/components/layout/SearchPalette';
import { Button } from '@/components/ui/button';

/** An address the portal does not have: say so in plain words and offer the way back to the dashboard, and
 *  (inside the layout) the global search, for whoever was looking for one load or carrier (notfound H2). */
export function NotFound() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const palette = useSearchPalette();
  return (
    <StateShell icon={TriangleAlert} title={t('pages.notFound.title')} compact className="mt-4 max-w-[560px] sm:mt-8">
      <p className="text-sm text-ink-secondary">{t('pages.notFound.blurb')}</p>
      {/* UX audit portal-notfound H3: the address that was asked for, as a mono pill set apart from the prose. */}
      <p
        className="max-w-full rounded-sm bg-sunken px-2 py-0.5 font-mono text-xs break-all text-ink-secondary"
        data-testid="notfound-path"
      >
        {pathname}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-2">
        <Button asChild size="sm">
          <Link to="/dashboard">{t('pages.notFound.back')}</Link>
        </Button>
        {palette && (
          <Button type="button" variant="outline" size="sm" onClick={palette.openSearch}>
            <Search className="size-4" aria-hidden="true" />
            {t('pages.notFound.search')}
            <kbd className="rounded-sm border border-hairline px-1 text-xs font-medium text-ink-muted">{searchShortcut()}</kbd>
          </Button>
        )}
      </div>
    </StateShell>
  );
}
